export enum UcService {
  MOVING_IMAGE = 'MovingImage',
  FRESH_CHAT = 'Freshdesk'
}
